// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.iris-eye {
    margin: auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    width: fit-content;
}
.p-tabview-panels,
.mimetika-slider{
    font-family: 'Montserrat', sans-serif !important; /* Default font */
}
.mimetika-slider.p-slider.p-slider-horizontal {
    height: 1.18rem;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 9px;
}
.mimetika-slider.p-slider .p-slider-range {
    background: var(--blue);
    border-radius: 9px
}
.mimetika-slider.p-slider .p-slider-handle {
    display: none;
}

.mimetika-slider.p-slider .p-slider-handle:focus {
    box-shadow: none;
}

.mimetika-slider.p-slider:not(.p-disabled) .p-slider-handle:hover {
    background: var(--blue);
}
`, "",{"version":3,"sources":["webpack://./src/css/pupil.css"],"names":[],"mappings":";;AAEA;IACI,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;IAEI,gDAAgD,EAAE,iBAAiB;AACvE;AACA;IACI,eAAe;IACf,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB;AACJ;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["\n\n.iris-eye {\n    margin: auto;\n    left: 0;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    text-align: center;\n    width: fit-content;\n}\n.p-tabview-panels,\n.mimetika-slider{\n    font-family: 'Montserrat', sans-serif !important; /* Default font */\n}\n.mimetika-slider.p-slider.p-slider-horizontal {\n    height: 1.18rem;\n    background: rgba(255, 255, 255, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    border-radius: 9px;\n}\n.mimetika-slider.p-slider .p-slider-range {\n    background: var(--blue);\n    border-radius: 9px\n}\n.mimetika-slider.p-slider .p-slider-handle {\n    display: none;\n}\n\n.mimetika-slider.p-slider .p-slider-handle:focus {\n    box-shadow: none;\n}\n\n.mimetika-slider.p-slider:not(.p-disabled) .p-slider-handle:hover {\n    background: var(--blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
